module.exports = __webpack_public_path__ + "media/images/emblems/Vinzel-coat_of_arms-453d8bec3644e844a67a901fd8ded002.svg";